

export let colPersonNum = {colId: 'personNum', headerName: 'Number', field: 'contactNum',width: 100, sortable: true};
export let colFullName = {colId: 'fullName', headerName: 'Full Name', field: 'fullName',width: 100, sortable: true };
export let colTitle = {colId: 'title', headerName: 'Title', field: 'title',width: 100, sortable: true };
export let colPrimaryParty = {colId: 'primaryParty', headerName: 'Party', field: 'primaryVendorFriendlyName', width: 100, sortable: true };
export let colDepartment = {colId: 'department', headerName: 'Department', field: 'department',width: 100, sortable: true };
export let colPrimaryPhone = {colId: 'primaryPhone', headerName: 'Primary Phone', field: 'primaryPhone', width: 100, sortable: true};
export let colEmail = {colId: 'email', headerName: 'Email', field: 'email', width: 100, sortable: true};
export let colFunction = {colId: 'function', headerName: 'Function', field: 'function', width: 100, sortable: true};
export let colPrefix = {colId: 'prefix', headerName: 'Prefix', field: 'prefix', width: 100, sortable: true};
export let colStreetAddress = {colId: 'streetAddress', headerName: 'Street Address', field: 'address', width: 100, sortable: true};
export let colCity = {colId: 'city', headerName: 'City', field: 'city', width: 100, sortable: true};
export let colState = {colId: 'state', headerName: 'State', field: 'state', width: 100, sortable: true};
export let colZip = {colId: 'zip', headerName: 'Zip', field: 'zip', width: 100, sortable: true};
export let colSecondaryEmail = {colId: 'secondaryEmail', headerName: 'Secondary Email', field: 'email2', width: 100, sortable: true};
export let colSecondaryCity = {colId: 'secondaryCity', headerName: 'Secondary City', field: 'secondaryCity', width: 100, sortable: true};
export let colSecondaryState = {colId: 'secondaryState',
                                headerName: 'Secondary State', field: 'secondaryState', width: 100, sortable: true};
export let colSecondaryZip = {colId: 'secondaryZip', headerName: 'Secondary Zip', field: 'secondaryZip', width: 100, sortable: true};
export let colFax = {colId: 'fax', headerName: 'Fax', field: 'faxPhone', width: 100, sortable: true};
export let colOfficePhone = {colId: 'secondaryPhone', headerName: 'Secondary Phone', field: 'secondaryPhone', width: 100, sortable: true};
export let colSuffix = {colId: 'suffix', headerName: 'Suffix', field: 'suffix', width: 100, sortable: true};


export let allColumns = [

    colPersonNum,
    colFullName,
    colTitle,
    colPrimaryParty,
    colDepartment,
    colPrimaryPhone,
    colEmail,
    colFunction,
    colPrefix,
    colStreetAddress,
    colCity,
    colState,
    colZip,
    colSecondaryEmail,
    colSecondaryCity,
    colSecondaryState,
    colSecondaryZip,
    colFax,
    colOfficePhone,
    colSuffix

]



export let columnSelectList = [
    {
      value: colPersonNum,
      viewValue: colPersonNum.headerName
    },
    {
      value: colFullName,
      viewValue: colFullName.headerName
    },
    {
      value: colTitle,
      viewValue: colTitle.headerName
    },
    {
      value: colPrimaryParty,
      viewValue: colPrimaryParty.headerName
    },
    {
      value: colDepartment,
      viewValue: colDepartment.headerName
    },
    {
      value: colPrimaryPhone,
      viewValue: colPrimaryPhone.headerName
    },
    {
      value: colEmail,
      viewValue: colEmail.headerName
    },
    {
      value: colFunction,
      viewValue: colFunction.headerName
    },

    {
      value: colPrefix,
      viewValue: colPrefix.headerName
    },
    {
      value: colStreetAddress,
      viewValue: colStreetAddress.headerName
    },
    {
      value: colCity,
      viewValue: colCity.headerName
    },
    {
      value: colState,
      viewValue: colState.headerName
    },
    {
      value: colZip,
      viewValue: colZip.headerName
    },
    {
      value: colSecondaryEmail,
      viewValue: colSecondaryEmail.headerName
    },
    {
      value: colSecondaryCity,
      viewValue: colSecondaryCity.headerName
    },
    {
      value: colSecondaryState,
      viewValue: colSecondaryState.headerName
    },
    {
      value: colSecondaryZip,
      viewValue: colSecondaryZip.headerName
    },
    {
      value: colFax,
      viewValue: colFax.headerName
    },
    {
      value: colSuffix,
      viewValue: colSuffix.headerName
    },
    {
      value: colOfficePhone,
      viewValue: colOfficePhone.headerName
    }

  ];
